import { Attr, BelongsTo, HasOne, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Favorite from "./Favorite";
import type Organisation from "./Organisation";
import type Stream from "./Stream";
import type User from "./User";

export enum StreamReportStatus {
  DONE = "done",
  ERROR = "error",
  HTML_COMPLETED = "html_completed",
  PROCESSING = "processing",
}
@Model()
class StreamReport extends ApplicationRecord {
  static jsonapiType = "stream_reports";

  @Attr() after: number;

  @Attr() before: number;

  @Attr() collapseSyndicated: boolean;

  @Attr() createdAt: string;

  @Attr() csv: boolean;

  @Attr() csvUrl: string;

  @Attr() displayCharts: boolean;

  @Attr() displayMentions: boolean;

  @Attr() excludedItems: string[];

  @HasOne() favorite: Favorite;

  @Attr() fileUrl: string;

  @Attr() format: string;

  @Attr() formats: string;

  @Attr() includePrintClipsPdf: boolean;

  @Attr() insightsType: string;

  @Attr() label: string;

  @Attr() note: string;

  @Attr() options: Record<string, any>;

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() organisationTeamId: number;

  @Attr() pdf: boolean;

  @Attr() pdfUrl: string;

  @Attr() publicHtmlUrl: string;

  @Attr() reportType: string;

  @Attr() sortBy: string;

  @Attr() sortOrder: string;

  @Attr() status: StreamReportStatus;

  @BelongsTo() stream: Stream;

  @Attr() streamId: number;

  @Attr({ dirtyChecker: () => false, persist: false })
  streamsData: Stream[];

  @Attr() timeZone: string;

  @Attr() types: string[];

  @BelongsTo() user: User;

  @Attr() userId: number;

  @Attr() xlsxUrl: string;

  hasFiles(): boolean {
    return Boolean(this.pdfUrl || this.csvUrl || this.xlsxUrl);
  }
}

export default StreamReport;
